import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from '@nolimitcity/slot-game/bin/core/particles/ParticlesManager';
import {GameResources} from '@nolimitcity/slot-game/bin/core/resource/GameResources';
import {ScalableLayer} from '@nolimitcity/slot-game/bin/core/stage/ScalableLayer';
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from 'pixi-particles';
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {HorribleHeroesEvents} from "../events/HorribleHeroesEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class ParticleAnimation extends BaseView {

    private _fireParticlesEmitersLeft: Emitter[];

    private _fireParticlesEmitersRight: Emitter[];
    private _fireParticlesEmitersCenter: Emitter[];

    private shadeWidth: number = HorribleHeroesGameConfig.instance.GAME_WIDTH;
    private shadeHeight: number = HorribleHeroesGameConfig.instance.GAME_HEIGHT;


    private _layer: ScalableLayer;
    private _layer_foreground: ScalableLayer;
    private _rainDropBGEmiters: Emitter[];
    private _rainDropLeftEmitersFG: Emitter[];
    private _rainDropRightEmitersFG: Emitter[];
    private _rainDropRightEmiters: Emitter[];
    private _rainDropCenterEmiters: Emitter[];
    private _rainDropCenterSmallEmiters: Emitter[];
    private _foreGroundContainer: PIXI.Container;
    private _particleContainer: PIXI.Container;
    private _fireContainer: PIXI.Container;
    private _idIdlePlaying: boolean = false;
    private readonly _rainDropCenterSmallConfig: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1,
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.7,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "blendMode": "add",
            "maxSpeed": 10000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 10,
                "max": 10
            },
            "frequency": 0.01,
            "emitterLifetime": -1,
            "maxParticles": 200,
            "pos": {
                "x": -280,
                "y": -650,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH + 600,
                "h": 0
            }
        }
    ];
    /**
     * configuration of rain Drop for ReelArea Part also visible in portrait
     */
    private readonly _rainDropCenterConfig: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1,
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.7,
                "end": 0.7,
                "minimumScaleMultiplier": 1
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "blendMode": "add",
            "maxSpeed": 1000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 10,
                "max": 10
            },
            "frequency": 0.05,
            "emitterLifetime": -1,
            "maxParticles": 400,
            "pos": {
                "x": -280,
                "y": -650,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH + 600,
                "h": 0
            }
        }
    ];
    /**
     * configuration of rain Drop for left part above logo
     */
    private readonly _rainDropConfigsForReelLeftFG: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1,
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.2,
                "end": 0.9,
                "minimumScaleMultiplier": 1
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "blendMode": "add",
            "maxSpeed": 10000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "frequency": 0.01,
            "emitterLifetime": -1,
            "maxParticles": 200,
            "pos": {
                "x": -280,
                "y": -650,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 200,
                "h": 0
            }
        }
    ];
    /**
     * configuration of rain Drop for left part below logo
     */
    private readonly _rainDropConfigsForReelLeft: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 1,
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "scale": {
                "start": 0.3,
                "end": 0.6,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "blendMode": "add",
            "maxSpeed": 1000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "speed": {
                "start": 100,
                "end": 50,
                "minimumSpeedMultiplier": 1
            },
            "frequency": 0.01,
            "emitterLifetime": -1,
            "maxParticles": 500,
            "pos": {
                "x": -220,
                "y": -650,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 700,
                "h": 0
            }
        }
    ];
    /**
     * configuration of rain Drop for right part
     */
    private readonly _rainDropConfigsForReelRightFG: any[] = [
        {
            "alpha": {
                "start": 0.8,
                "end": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "scale": {
                "start": 0.2,
                "end": 0.9,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "maxSpeed": 10000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "frequency": 0.01,
            "emitterLifetime": -1,
            "maxParticles": 200,
            "pos": {
                "x": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH + 40,
                "y": -650,
            },
            "blendMode": "add",
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 300,
                "h": 0
            }
        }
    ];
    /**
     * configuration of rain Drop for right part
     */
    private readonly _rainDropConfigsForReelRight: any[] = [
        {
            "alpha": {
                "start": 0.8,
                "end": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "skew": {
                "x": -15,
                "y": 0,
            },
            "scale": {
                "start": 0.3,
                "end": 0.3,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": -15,
                "y": 1500
            },
            "maxSpeed": 10000,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "frequency": 0.01,
            "emitterLifetime": -1,
            "maxParticles": 200,
            "pos": {
                "x": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH - 40,
                "y": -650,
            },
            "blendMode": "add",
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 400,
                "h": 0
            }
        }
    ];
    /**
     * config to play emiiter from for ReelArea Part also visible in portrait
     */
    private readonly _firParticleConfigsCenter: any[] = [
        {
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.5,
                "end": 0.8,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -15
            },
            "maxSpeed": 100,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 15,
                "max": 15
            },
            "frequency": 0.7,
            "emitterLifetime": -1,
            "maxParticles": 20,
            "pos": {
                "x": 0,
                "y": this.shadeHeight / 2,
            },
            "blendMode": "add",
            "addAtBack": true,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH,
                "h": this.shadeHeight / 2
            }
        }
    ];
    /**
     * config to play emiiter in  Left
     */
    private readonly _firParticleConfigsLeft: any[] = [
        {
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.5,
                "end": 0.8,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -15
            },
            "maxSpeed": 100,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 10,
                "max": 10
            },
            "frequency": 0.7,
            "emitterLifetime": -1,
            "maxParticles": 20,
            "pos": {
                "x": -220,
                "y": this.shadeHeight / 2,
            },
            "blendMode": "add",
            "addAtBack": true,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 300,
                "h": this.shadeHeight / 2
            }
        }
    ];
    /**
     * config to play emiiter in right
     */
    private readonly _firParticleConfigsRight: any[] = [
        {
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },

            "scale": {
                "start": 0.5,
                "end": 0.8,
                "minimumScaleMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -15
            },
            "maxSpeed": 100,
            "noRotation": true,
            "startRotation": {
                "min": 90,
                "max": 0
            },
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 10,
                "max": 10
            },
            "frequency": 0.7,
            "emitterLifetime": -1,
            "maxParticles": 20,
            "pos": {
                "x": HorribleHeroesGameConfig.instance.REEL_AREA_WIDTH,
                "y": this.shadeHeight / 2,
            },
            "blendMode": "add",
            "addAtBack": true,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": this.shadeWidth,
                "h": this.shadeHeight / 2
            }
        }
    ];

    /**
     * function to start emitting particles
     */
    public playAnimation() {
        if (this._idIdlePlaying) {
            return;
        }
        this._idIdlePlaying = true;
        this._rainDropBGEmiters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._rainDropCenterEmiters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._rainDropCenterSmallEmiters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._rainDropLeftEmitersFG.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._rainDropRightEmiters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._rainDropRightEmitersFG.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._fireParticlesEmitersLeft.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });

        this._fireParticlesEmitersRight.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
        this._fireParticlesEmitersCenter.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });


    }

    /**
     * fucniton to stop emitting particle
     */
    public stopAnimation() {
        this._idIdlePlaying = false;

        this._rainDropBGEmiters.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });

        this._rainDropCenterEmiters.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._rainDropCenterSmallEmiters.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._rainDropLeftEmitersFG.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._rainDropRightEmiters.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._rainDropRightEmitersFG.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._fireParticlesEmitersLeft.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._fireParticlesEmitersRight.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });
        this._fireParticlesEmitersCenter.forEach((emitter: Emitter) => {
            emitter.cleanup();
            emitter.emit = false;
        });

        this._layer.addChild(this._foreGroundContainer);
    }

    protected initAnimations(): void {
        this._layer = StageManager.getLayer(HorribleHeroesGameConfig.instance.LAYERS.BACKGROUND.name);
        this._layer_foreground = StageManager.getLayer(HorribleHeroesGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._layer.visible = true;
        this._particleContainer = new PIXI.Container();
        this._fireContainer = new PIXI.Container();
        this._layer.addChild(this._particleContainer);
        this._layer.addChild(this._fireContainer);
        this._particleContainer.name = "particleContainer";

        this._foreGroundContainer = new PIXI.Container();
        this._layer.addChild(this._foreGroundContainer);

        this.addIdleRainDropInBackground();
        this.addIdleRainDropInForeground();
        this.createFireParticlesAnimationEmitterFomRight();
        this.addEventListeners();

    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, HorribleHeroesEvents.PLAY_FS_FIRE_PARTICLES, (event: GameEvent) => this.playAnimation());
        EventHandler.addEventListener(this, HorribleHeroesEvents.STOP_FS_FIRE_PARTICLES, (event: GameEvent) => this.stopAnimation());
        EventHandler.addEventListener(this, HorribleHeroesEvents.CHANGE_LAYERS, (event: GameEvent) => this.changeLayers());
    }

    /**
     * function to rezize the dimmer/alpha lyer of the bg
     * @param resizeData
     */
    protected onResize?(resizeData: IResizeData): void {
    }

    private changeLayers() {
        // this._layer_foreground.addChild(this._foreGroundContainer);
    }

    /**
     * function to create firefly animaiton from right
     */
    private createFireParticlesAnimationEmitterFomRight() {
        this._fireParticlesEmitersLeft = [];
        this._firParticleConfigsLeft.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._fireContainer, [{
                framerate: 20,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("fireParticles")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._fireParticlesEmitersLeft.push(emitter);
        });

        this._fireParticlesEmitersRight = [];
        this._firParticleConfigsRight.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._fireContainer, [{
                framerate: 20,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("fireParticles")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._fireParticlesEmitersRight.push(emitter);
        });
        this._fireParticlesEmitersCenter = [];
        this._firParticleConfigsCenter.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._fireContainer, [{
                framerate: 20,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("fireParticles")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._fireParticlesEmitersCenter.push(emitter);
        });
    }

    /**
     * function to create rain drop emitter for foreground
     */
    private addIdleRainDropInForeground() {
        this._rainDropRightEmiters = [];
        this._rainDropConfigsForReelRight.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._particleContainer, [GameResources.getTextures("backRainDrop")[0]], config);
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropRightEmiters.push(emitter);
        });
        this._rainDropRightEmitersFG = [];
        this._rainDropConfigsForReelRightFG.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._foreGroundContainer, [GameResources.getTextures("backRainDrop")[0]], config);
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropRightEmitersFG.push(emitter);
        });
    }

    /**
     * funciton to create rainDrop emitter for reelArea BG
     */
    private addIdleRainDropInBackground() {
        this._rainDropBGEmiters = [];

        this._rainDropConfigsForReelLeft.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._foreGroundContainer, [GameResources.getTextures("backRainDrop")[0]], config);
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropBGEmiters.push(emitter);
        });
        this._rainDropCenterEmiters = [];
        this._rainDropCenterConfig.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._foreGroundContainer, [GameResources.getTextures("frontRainDrop")[0]], config);
            //GameResources.getTextures("frontRainDrop")[0]
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropCenterEmiters.push(emitter);
        });
        this._rainDropCenterSmallEmiters = [];
        this._rainDropCenterSmallConfig.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._foreGroundContainer, [GameResources.getTextures("backRainDrop")[0]], config);
            //GameResources.getTextures("frontRainDrop")[0]
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropCenterSmallEmiters.push(emitter);
        });
        this._rainDropLeftEmitersFG = [];
        this._rainDropConfigsForReelLeftFG.forEach((config: any) => {
            const emitter: Emitter = new Emitter(this._foreGroundContainer, [GameResources.getTextures("backRainDrop")[0]], config);
            ParticlesManager.addEmitter(emitter, false);
            this._rainDropLeftEmitersFG.push(emitter);
        });
    }

}